import { Link } from "react-router-dom";
import { FadeUp } from "@/components/Reveal";

const navLinks = [
  { label: "Services", to: "/#what-we-do" },
  { label: "Blog", to: "/blogs" },
  { label: "Contact Us", to: "/contact" },
];

const socialLinks = [
  { label: "LinkedIn", href: "https://www.linkedin.com/company/ophodigital/about/" },
  { label: "Instagram", href: "https://www.instagram.com/opho_digital" },
  { label: "Facebook", href: "https://www.facebook.com/ophodigital" },
];

const Footer = () => (
  <footer data-testid="site-footer" className="relative z-10 w-full">
    <div className="relative site-container">
      <FadeUp>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          {/* Left — logo + description */}
          <div className="lg:col-span-5">
            <img src="/assets/logo.svg" alt="OPHO Digital" className="h-10 w-auto" />
            <p className="mt-6 max-w-md text-sm leading-relaxed text-[#111]/60">
              We provide integrated digital marketing solutions ensuring unified messaging across platforms. From SEO and content marketing to social media marketing and PPC advertising, we create solutions aligned with your business goals.
            </p>
          </div>

          {/* Right — 3 link columns */}
          <div className="lg:col-span-7 flex flex-wrap gap-10 lg:gap-12 xl:gap-16 lg:justify-end">
            {/* Navigation */}
            <div>
              <h4 className="text-sm font-semibold text-[#111] uppercase tracking-wider mb-4">Navigation</h4>
              <ul className="space-y-3">
                {navLinks.map(({ label, to }) => (
                  <li key={label}>
                    <Link
                      data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                      to={to}
                      className="text-sm text-[#111]/60 hover:text-[#8C5EBA] transition-colors"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Socials */}
            <div>
              <h4 className="text-sm font-semibold text-[#111] uppercase tracking-wider mb-4">Socials</h4>
              <ul className="space-y-3">
                {socialLinks.map(({ label, href }) => (
                  <li key={label}>
                    <a
                      href={href}
                      target="_blank"
                      rel="noreferrer"
                      aria-label={label}
                      className="text-sm text-[#111]/60 hover:text-[#8C5EBA] transition-colors"
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-sm font-semibold text-[#111] uppercase tracking-wider mb-4">Contact</h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="mailto:info@ophodigital.com"
                    className="text-sm text-[#111]/60 hover:text-[#8C5EBA] transition-colors"
                  >
                    info@ophodigital.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 border-t border-[#8C5EBA]/40 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p data-testid="footer-copyright" className="text-[15px] font-medium text-[#8C5EBA]">
            © 2026 OPHO Digital. All rights reserved.
          </p>
          <div className="flex items-center gap-3 text-[15px] font-medium text-[#8C5EBA]">
            <Link to="/terms" className="hover:underline">Terms and Conditions</Link>
            <span className="text-[#111]/30">•</span>
            <Link to="/privacy" className="hover:underline">Privacy Policy</Link>
          </div>
        </div>
      </FadeUp>
    </div>
  </footer>
);

export default Footer;
